import { httpClient } from '@shared/js/api/httpClient';
import { normalizeCheckoutQuoteResponse } from '@shared/js/payments/checkoutQuoteFormat';

export default {
	data() {
		return {
			checkoutQuote:          null,
			isCheckoutQuoteLoading: false,
		};
	},
	computed: {
		checkoutQuoteWatchKey() {
			const offerId = this.offer?.id ?? '';
			const eventId = this.checkoutQuoteEventId ?? '';
			const voucherId = this.checkoutQuoteVoucherId ?? '';
			const loggedIn = this.isLoggedIn === false ? '0' : '1';

			return `${loggedIn}-${offerId}-${eventId}-${voucherId}`;
		},
		checkoutQuoteEventId() {
			return null;
		},
		checkoutQuoteVoucherId() {
			return null;
		},
	},
	watch: {
		checkoutQuoteWatchKey: {
			handler() {
				this.loadCheckoutQuote();
			},
			immediate: true,
		},
	},
	methods: {
		async loadCheckoutQuote() {
			if (!this.offer?.id || this.isLoggedIn === false) {
				this.checkoutQuote = null;
				return;
			}

			this.isCheckoutQuoteLoading = true;

			try {
				const response = await httpClient.getPaymentCheckoutQuote({
					offerId:   this.offer.id,
					eventId:   this.checkoutQuoteEventId,
					voucherId: this.checkoutQuoteVoucherId,
				});
				this.checkoutQuote = normalizeCheckoutQuoteResponse(response?.data);
			} catch (error) {
				console.error('checkoutQuoteMixin - failed to load checkout quote', error);
				this.checkoutQuote = null;
			} finally {
				this.isCheckoutQuoteLoading = false;
			}
		},
	},
};
